<template>
  <div v-if="promo"
    class="FeaturedPromo flex rounded-3xl overflow-hidden bg-gradient-to-br from-primary-500 to-tertiary-400 dark:from-primary-darker dark:to-primary-dark relative">
    <img :src="`${promo.book?.cover || promo.book_cover}?h=1200&q=1&auto=format&blur=500`"
      class="absolute inset-0 h-full w-full mix-blend-overlay" alt="" />
    <subdomain-link :href="route('listen.promo.view', { promo, team })"
      target="_blank" rel="noopener"
      class="flex flex-col sm:flex-row items-center sm:items-start justify-center sm:space-x-gr-6 p-gr-7 relative group">
      <img :src="`${promo.book?.cover || promo.book_cover}?w=1800&q=1&auto=format`"
        class="sm:w-grp-4 w-grp-5 rounded shadow-lg duration-200 group-hover:shadow-xl" alt="" />

      <div class="max-w-sm md:max-w-md text-center sm:text-left sm:mr-auto">
        <div class="label text-primary-800/60 dark:text-primary-200/60">
          {{ book.is_abridged ? 'Abridged' : 'Unabridged' }} {{ book.format }}
        </div>
        <h1 class="mt-gr-7 sm:mt-0 text-3xl font-bolder leading-gr-7 bg-clip-text bg-gradient-to-br">
          {{ book.title }}
        </h1>
        <h2 v-if="book.subtitle" class="text-2xl leading-gr-7">
          {{ book.subtitle }}
        </h2>
        <span v-if="book.author_list"
          :href="route('browse') + `#/selectedAuthors=${book.author_list.replace(', ', ',')}`"
          class="block mt-gr-5 font-bold group">
          <i class="fa-light fa-fw fa-pen-line mr-gr-3" title="Written by"></i>
          <span class="">{{ book.author_list }}</span>
          <!-- <span class="group-hover:underline">{{ book.author_list }}</span> -->
        </span>
        <span v-if="book.narrator_list"
          :href="route('browse') + `#/selectedNarrators=${book.narrator_list.replace(', ', ',')}`"
          class="block opacity-50 font-bold duration-300 group">
          <!-- class="block opacity-50 font-bold hover:opacity-100 duration-300 group" -->
          <i class="fa-light fa-fw fa-waveform mr-gr-3" title="Read by"></i>
          <span class="">{{ book.narrator_list }}</span>
          <!-- <span class="group-hover:underline">{{ book.narrator_list }}</span> -->
        </span>
        <span v-if="book.publisher_list" :href="route('browse') + `#/selectedPublishers=${book.publisher_list.replace(', ', ',')}`
          " class="block opacity-50 font-bold duration-300 group">
          <i class="fa-light fa-fw fa-books mr-gr-3" title="Published by"></i>
          <span class="">{{ book.publisher_list }}</span>
          <!-- <span class="group-hover:underline">{{ book.publisher_list }}</span> -->
        </span>
        <div v-if="book.runtime || book.language || book.isbn"
          class="label text-primary-800/60 dark:text-primary-200/60 flex divide-x items-center justify-center sm:justify-start sm:-ml-gr-3 divide-primary-500/60 leading-none mt-gr-6">
          <div v-if="book.runtime" class="px-gr-3">{{ formattedRuntime }}</div>
          <div v-if="book.language" class="px-gr-3">{{ book.language }}</div>
          <div v-if="book.isbn" class="px-gr-3">
            ISBN: <span class="whitespace-nowrap">{{ book.isbn }}</span>
          </div>
        </div>

        <div v-if="book.description" class="mt-gr-6">
          <div :class="[
            'overflow-hidden',
            showDescription ? 'to-primary-dark dark:to-white h-auto' : 'to-transparent h-gr-double-7',
            isSafari
              ? 'text-primary-dark dark:text-white'
              : 'bg-clip-text bg-gradient-to-b from-primary-dark dark:from-white text-transparent',
          ]">
            <div v-html="book.description" class="text-sm"></div>
          </div>
          <button class="link text-primary-800 hover:text-primary-600 focus:text-primary-600 dark:!text-white/60 text-xs underline focus:ring-0"
            @click.prevent.stop="showDescription = !showDescription">
            <span class="mr-gr-2">{{ showDescription ? 'Less' : 'More' }}</span><span
              :class="['inline-block duration-200', showDescription ? 'rotate-180' : 'rotate-0']"><i
                class="fa fa-sm fa-fw fa-chevron-down"></i></span>
          </button>
        </div>
      </div>
    </subdomain-link>
  </div>
</template>

<script>
import { isSafari, isMobile } from '@/Utils/device';

export default {
  name: 'FeaturedPromo',

  props: {
    promo: {
      type: Object,
    },
  },

  data() {
    return {
      showDescription: false,
      isSafari,
      isMobile,
    };
  },

  computed: {
    book() {
      return this.promo?.book;
    },

    team() {
      return this.promo?.team;
    },

    formattedRuntime() {
      let seconds = this.book?.runtime || 0;

      let runtimeH = Math.floor(seconds / 60 / 60);
      let runtimeM = Math.floor(seconds / 60 - runtimeH * 60);
      let runtimeS = Math.floor(seconds - runtimeH * 60 * 60 - runtimeM * 60);

      let label = '';
      if (runtimeH > 0) {
        label += `${runtimeH}${runtimeH !== 1 ? 'h' : 'h'}`;
      }
      if (runtimeM > 0) {
        label += ` ${runtimeM}${runtimeM !== 1 ? 'm' : 'm'}`;
      }

      return label;
    },
  },

  methods: {
    printValue(value) {
      if (Array.isArray(value)) return value.join(', ');
      return value;
    },
  },
};
</script>

<!-- <style lang="scss" src="./FeaturedPromos.scss" scoped></style> -->
